import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretSmallUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.3169 12.3169C15.0729 12.561 14.6771 12.561 14.4331 12.3169L10.5 8.38388L6.56694 12.3169C6.32286 12.561 5.92713 12.561 5.68306 12.3169C5.43898 12.0729 5.43898 11.6771 5.68306 11.4331L10.0581 7.05806C10.3021 6.81398 10.6979 6.81398 10.9419 7.05806L15.3169 11.4331C15.561 11.6771 15.561 12.0729 15.3169 12.3169Z"
	})
});
export default SvgCaretSmallUp;
